/**
 * OVERRIDE View.jsx
 * REASON: This theme introduces the concept of "Caption" and uses `figure`
 * tag for the image.
 */

import ImageView from '../../../../../../components/Blocks/Image/View';

export default ImageView;
